.stars {
  color: var(--amber);
  letter-spacing: 2px;
  white-space: nowrap;
}
